import * as React from "react";
import * as ReactDOM from "react-dom/client";
import Cidr from "../Tools/Cidr";

const appElement = document.getElementById("app");
const root = ReactDOM.createRoot(appElement);
root.render(<Cidr />);
